import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { useIntl } from 'react-intl'
import { NavLink } from 'react-router-dom'
import Avatar from '../assets/svgs/avatar'

import { useAuth } from '../contexts/AuthContext'
import { useState } from 'react'
import clsx from 'clsx'

type ProfileMenuProps = {
  hasTermOfParticipation?: boolean
  hasTranslations?: boolean
}

export const ProfileMenu = ({
  hasTermOfParticipation = true,
  hasTranslations = true,
}: ProfileMenuProps) => {
  const { user, signOut } = useAuth()
  const { formatMessage } = useIntl()
  const [open, setOpen] = useState(false)

  return (
    <DropdownMenu.Root
      onOpenChange={(open) => {
        setOpen(open)
      }}
    >
      <DropdownMenu.Trigger asChild>
        <button className="outline-none">
          <Avatar
            className={clsx({
              'text-grey-700': !open,
              'text-secondary-dark': open,
            })}
          />
        </button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          className="z-50 items-center mt-2 bg-white border border-gray-300 rounded-lg shadow-lg w-72"
          align="end"
        >
          <header className="flex items-center gap-4 px-4 py-6 border-b border-gray-300">
            <div className="flex flex-col justify-center">
              <span className="block font-normal text-grey-900">
                {user?.name}
              </span>
              <span className="text-sm font-normal text-grey-700">
                {user?.email}
              </span>
            </div>
          </header>

          <DropdownMenu.DropdownMenuGroup className="p-6 space-y-6">
            {hasTermOfParticipation && (
              <DropdownMenu.DropdownMenuItem>
                <NavLink
                  to="/expert/term-of-participation"
                  className=" text-grey-800"
                >
                  {hasTranslations
                    ? formatMessage({ id: 'TERM_OF_PARTICIPATION' })
                    : 'Termo de participação'}
                </NavLink>
              </DropdownMenu.DropdownMenuItem>
            )}
            <DropdownMenu.DropdownMenuItem>
              <NavLink
                to={`/${
                  user?.type === 'expert' ? 'expert' : 'painel'
                }/change-password`}
                className="outline-none text-grey-800"
              >
                {hasTranslations
                  ? formatMessage({ id: 'CHANGE_PASSWORD' })
                  : 'Alterar senha'}
              </NavLink>
            </DropdownMenu.DropdownMenuItem>
            <DropdownMenu.DropdownMenuItem>
              <NavLink
                to={`/${user?.type === 'expert' ? 'expert' : 'painel'}/logout`}
                onClick={signOut}
                className="outline-none text-grey-800"
              >
                {hasTranslations ? formatMessage({ id: 'LOGOUT' }) : 'Sair'}
              </NavLink>
            </DropdownMenu.DropdownMenuItem>
          </DropdownMenu.DropdownMenuGroup>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}
